import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import BrokenImageOutlined from "@mui/icons-material/BrokenImageOutlined";
import { Box, Button, Stack, Typography } from "@mui/material";
import { $getNodeByKey, type NodeKey } from "lexical";
import type { FC } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useDialog } from "../../utils/hooks/use-dialog";
import { AddImagesAndFilesModal } from "../message/editor/plugins/toolbar/add-images-and-files-modal";

export const FailedDesignHuddlePreview: FC<{
  nodeKey: NodeKey;
}> = ({ nodeKey }) => {
  const { t } = useTranslation();
  const [editor] = useLexicalComposerContext();
  const dialog = useDialog();

  return (
    <>
      <Stack
        display="flex"
        alignItems="center"
        gap={1}
        justifyContent="center"
        sx={{
          maxWidth: "400px",
          border: "1px solid",
          borderColor: "error.main",
          backgroundColor: "#FAECEC",
          borderRadius: "2px",
        }}
      >
        <Box pt={6}>
          <BrokenImageOutlined sx={{ fontSize: 56, color: "error.light" }} />
        </Box>
        <Trans>
          <Typography variant="body2" color="gray.500" align="center">
            Image failed to load. You can try again or delete this placeholder. If this error
            persists, please contact support@changeengine.com
          </Typography>
        </Trans>
        <Button
          data-analytics-id="failed-design-huddle-preview-try-again"
          onClick={dialog.handleOpen}
        >
          {t("Try Again")}
        </Button>
        <Button
          data-analytics-id="failed-design-huddle-preview-delete"
          color="error"
          onClick={() => {
            editor.update(() => {
              const node = $getNodeByKey(nodeKey);
              node && node.remove();
            });
          }}
        >
          {t("Delete")}
        </Button>
      </Stack>
      <AddImagesAndFilesModal
        open={dialog.open}
        onClose={() => {
          dialog.handleClose();
        }}
        nodeKey={nodeKey}
      />
    </>
  );
};
